import apiClient from './apiClient';
import Planner from '../models/Planner';

class PlannerService {
  async getPlanner(startDate, endDate) {
    const response = await apiClient.post(`/planner/get_plan`,{
      start_date: startDate,
      end_date: endDate
    });
    return response.plan_items.map(Planner.fromJson);
  }
}

const plannerServiceInstance = new PlannerService();
export default plannerServiceInstance; 
